export default __webpack_public_path__ + "static/media/arrow-01-green.5c0cba0a.svg";